












































import Vue from 'vue';
import MStoreSpinnerButton from '@/components/shared/MStoreSpinnerButton.vue';
import { MStoreForm } from '../shared';
import { AutoSaveConfigurationModel } from '@/types';
import { AutoSaveConfigurationService } from '@/services';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import SnotifyConfiguration from '@/classes/SnotifyConfiguration';
import { mapActions, mapGetters } from 'vuex';
import MStoreFormRadioButtonGroup from '@/components/shared/MStoreFormRadioButtonGroup.vue';
import { UserService } from '@/services/UserService';

export default Vue.extend({
  name: 'AutoSaveConfiguration',
  data() {
    return {
      isLoading: true,
      isSubmitting: false,
      loggedInUser: '',
      autoSaveConfiguration: {} as AutoSaveConfigurationModel
    };
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async onSubmitAsync(this: any) {
      this.isSubmitting = true;
      try {
        await AutoSaveConfigurationService.updateAutoSaveConfiguration(this.autoSaveConfiguration);
        SnotifyConfiguration.showSuccess('Auto Save Configuration updated.');
        this.setApplicationDirty(false);
      } catch (error) {
        this.$log('Error updating Auto Save Configuration', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    async onSubmitDefaultAsync(this: any) {
      this.isSubmitting = true;
      try {
        await AutoSaveConfigurationService.updateDefaultAutoSaveConfiguration(this.autoSaveConfiguration);
        SnotifyConfiguration.showSuccess('Default Auto Save Configuration updated.');
        this.setApplicationDirty(false);
      } catch (error) {
        this.$log('Error updating Default Auto Save Configuration', error);
      } finally {
        this.isSubmitting = false;
      }
    },
    onDirtyForm(this: any, isDirty: boolean) {
      this.setApplicationDirty(isDirty);
    }
  },
  computed: {
    autoSaveScopeOptions(this: any) {
      return [
        { value: 'AllUsers', text: 'All Users', disabled: !this.autoSaveConfiguration.enabled },
        { value: 'Me', text: `Me (${this.loggedInUser})`, disabled: !this.autoSaveConfiguration.enabled }
      ];
    }
  },
  async mounted() {
    this.loggedInUser = (await UserService.getCurrentUserAsync()).username;
    this.autoSaveConfiguration = await AutoSaveConfigurationService.getAutoSaveConfiguration();
    this.isLoading = false;
  },
  components: { MStoreSpinnerButton, MStoreForm, MStoreFormCheckbox, LoadingSpinner, MStoreFormRadioButtonGroup }
});
